export default __webpack_public_path__ + "static/media/icons8-menu-48.3524b5cb.svg";